import { render, staticRenderFns } from "./SolicitacaoInventarioList.vue?vue&type=template&id=a1154f46"
import script from "./SolicitacaoInventarioList.vue?vue&type=script&lang=js"
export * from "./SolicitacaoInventarioList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports